module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-MediumItalic.fbd4479a.woff2";